export const REQUESTS_TABLE_SCHEMA: any = [
    {
        Header: 'Request ID',
        accessor: 'requestId',
        customCell: true,
        sortable: false,
        fieldType: 'clickable'
    },
    {
        Header: 'Request Date',
        accessor: 'createdAt',
        customCell: true,
        fieldType: 'dateFormat'
    },
    {
        Header: 'Service Center Name',
        accessor: 'serviceCenterName'
    },
    {
        Header: 'Pilot ID',
        accessor: 'pilotId'
    },
    {
        Header: 'Pilot Name',
        accessor: 'pilotName'
    },
    {
        Header: 'Drone UIN',
        accessor: 'droneUIN'
    },
    {
        Header: 'Total Requested Quantity',
        accessor: 'totalRequestedQty'
    },
    {
        Header: 'Total Available Quantity',
        accessor: 'totalAvailable'
    },
    {
        Header: 'Total Approved Quantity',
        accessor: 'totalApprovedQty'
    },
    {
        Header: 'Approved Date',
        accessor: 'approvedDate',
        customCell: true,
        fieldType: 'dateFormat'
    },
    {
        Header: 'Request Status',
        accessor: 'requestStatus',
        customCell: true,
        fieldType: 'textColor'
    },
    {
        Header: 'Remarks',
        accessor: 'remarks'
    },
    {
        Header: 'Actions',
        accessor: '',
        customCell: true,
        fieldType: 'droneServices',
        view: false,
        download: false,
        edit: false,
        delete: false,
        takeAction: false,
        viewDetails: false
    }
];

export const USERS_SCHEMA = [
    {
        Header: 'User ID',
        accessor: 'refId'
    },
    {
        Header: 'User Name',
        accessor: 'fullName',
        customCell: true,
        sortable: false,
        fieldType: 'clickable'
    },
    {
        Header: 'Role',
        accessor: 'role',
        customCell: true,
        sortable: false,
        fieldType: 'clickable'
    },
    {
        Header: 'Mail ID',
        accessor: 'email'
    },
    {
        Header: 'Phone No.',
        accessor: 'phoneNumber'
    },
    {
        Header: 'Created By',
        accessor: 'createdBy'
    },
    {
        Header: 'Created Date',
        accessor: 'createdDate'
    },
    {
        Header: 'Actions',
        accessor: '',
        customCell: true,
        fieldType: 'takeAction',
        showEdit: 'showEdit',
        hideSwitch: 'hideSwitch',
        showComment: 'showComment',
        hideTakeAction: 'hideTakeAction'
    }
];

export const SOURCE_TABLE_SCHEMA = [
    {
        Header: 'Source ID',
        accessor: 'sourceRef'
    },
    {
        Header: 'Source Name',
        accessor: 'sourceName',
        maxWidth: '200px'
    },
    {
        Header: 'Area(In Hectares)',
        accessor: 'area'
    },
    {
        Header: 'Data Type',
        accessor: 'dataType'
    },
    {
        Header: 'Layer Type',
        accessor: 'layerType'
    },
    {
        Header: 'Priority',
        accessor: 'priority'
    },
    {
        Header: 'Source Display Name',
        accessor: 'sourceDisplayName'
    },
    {
        Header: 'Department Name',
        accessor: 'departmentName'
    },
    {
        Header: 'Sub Category',
        accessor: 'subCategoryName'
    },
    {
        Header: 'Source Link',
        accessor: 'sourceURL',
        maxWidth: '200px'
    },
    {
        Header: 'Visibility',
        accessor: 'visibilityString'
    },
    {
        Header: 'Open Access',
        accessor: 'openAccessString'
    },
    {
        Header: 'Source Data Visibility',
        accessor: 'identifierString'
    },
    // {
    //     Header: 'File Size',
    //     accessor: 'geoServerStorage'
    // },
    {
        Header: 'Created By',
        accessor: 'createdBy'
    },
    {
        Header: 'Created Date',
        accessor: 'createdAt',
        customCell: true,
        fieldType: 'dateFormat'
    },
    {
        Header: 'Modified By',
        accessor: 'updatedBy'
    },
    {
        Header: 'Modified Date',
        accessor: 'updatedAt',
        customCell: true,
        fieldType: 'dateFormat'
    },
    {
        Header: 'Approved By',
        accessor: 'approvedBy'
    },
    {
        Header: 'Approved Date',
        accessor: 'approvedAt',
        customCell: true,
        fieldType: 'dateFormat'
    },
    {
        Header: 'Actions',
        accessor: 'actions',
        customCell: true,
        fieldType: 'droneServices'
        // edit: true,
        // delete: true
    }
];

export const SOURCE3D_TABLE_SCHEMA = [
    {
        Header: 'Layer ID',
        accessor: 'source3DRef'
    },
    {
        Header: 'File Name',
        accessor: 'fileName'
    },
    {
        Header: 'File Link',
        accessor: 'fileURL',
        maxWidth: '200px'
    },
    {
        Header: 'Open Access',
        accessor: 'openAccessString'
    },
    {
        Header: 'Created By',
        accessor: 'createdBy'
    },
    {
        Header: 'Created Date',
        accessor: 'createdAt',
        customCell: true,
        fieldType: 'dateFormat'
    },
    {
        Header: 'Modified By',
        accessor: 'updatedBy'
    },
    {
        Header: 'Modified Date',
        accessor: 'updatedAt',
        customCell: true,
        fieldType: 'dateFormat'
    },
    {
        Header: 'Approved By',
        accessor: 'approvedBy'
    },
    {
        Header: 'Approved Date',
        accessor: 'approvedAt',
        customCell: true,
        fieldType: 'dateFormat'
    },
    {
        Header: 'Actions',
        accessor: 'actions',
        customCell: true,
        fieldType: 'droneServices'
        // edit: true,
        // delete: true
    }
];

export const REPORT_TABLE_SCHEMA = [
    {
        Header: 'Report ID',
        accessor: 'reportRef'
    },
    {
        Header: 'Deliverable Name',
        accessor: 'deliverableName'
    },
    {
        Header: 'Department',
        accessor: 'departmentName'
    },
    {
        Header: 'Sub-Category',
        accessor: 'subCategoryName'
    },
    {
        Header: 'Uploaded File',
        accessor: 'fileName'
    },
    {
        Header: 'Created By',
        accessor: 'createdBy'
    },
    {
        Header: 'Created Date',
        accessor: 'createdAt',
        customCell: true,
        fieldType: 'dateFormat'
    },
    // {
    //     Header: 'Modified By',
    //     accessor: 'updatedBy'
    // },
    // {
    //     Header: 'Modified Date',
    //     accessor: 'updatedAt',
    //     customCell: true,
    //     fieldType: 'dateFormat'
    // },
    {
        Header: 'Approved By',
        accessor: 'approvedBy'
    },
    {
        Header: 'Approved Date',
        accessor: 'approvedAt',
        customCell: true,
        fieldType: 'dateFormat'
    },
    {
        Header: 'Actions',
        accessor: 'actions',
        customCell: true,
        fieldType: 'droneServices',
        view: false,
        download: false,
        edit: false,
        // delete: false,
        takeAction: false,
        viewDetails: false
    }
];

export const DOWNLOAD_TABLE_SCHEMA = [
    {
        Header: 'Record ID',
        accessor: 'reportRef'
    },
    {
        Header: 'Deliverable Name',
        accessor: 'deliverableName'
    },
    {
        Header: 'Department',
        accessor: 'departmentName'
    },
    {
        Header: 'Sub-Category',
        accessor: 'subCategoryName'
    },
    // {
    //     Header: 'File Type',
    //     accessor: 'fileType'
    // },
    {
        Header: 'Uploaded File',
        accessor: 'fileName'
    },
    {
        Header: 'Created By',
        accessor: 'createdBy'
    },
    {
        Header: 'Created Date',
        accessor: 'createdAt',
        customCell: true,
        fieldType: 'dateFormat'
    },
    // {
    //     Header: 'Modified By',
    //     accessor: 'updatedBy'
    // },
    // {
    //     Header: 'Modified Date',
    //     accessor: 'updatedAt',
    //     customCell: true,
    //     fieldType: 'dateFormat'
    // },
    {
        Header: 'Approved By',
        accessor: 'approvedBy'
    },
    {
        Header: 'Approved Date',
        accessor: 'approvedAt',
        customCell: true,
        fieldType: 'dateFormat'
    },
    {
        Header: 'Actions',
        accessor: 'actions',
        customCell: true,
        fieldType: 'droneServices',
        view: false,
        download: false,
        edit: false,
        delete: true,
        takeAction: false,
        viewDetails: false
    }
];

export const EMPLOYEEID_TABLE_SCHEMA = [
    {
        Header: 'Employee ID',
        accessor: 'employeeID'
    },
    {
        Header: 'Created By',
        accessor: 'createdBy'
    },
    {
        Header: 'Created Date',
        accessor: 'createdAt'
    },
    {
        Header: 'Modified By',
        accessor: 'updatedBy'
    },
    {
        Header: 'Modified Date',
        accessor: 'updatedAt'
    },
    {
        Header: 'Actions',
        accessor: '',
        customCell: true,
        fieldType: 'droneServices',
        view: false,
        download: false,
        // edit: true,
        // delete: true,
        takeAction: false,
        viewDetails: false
    }
];

export const MODIFIED_LOGS_TABLE_SCHEMA = [
    {
        Header: 'ID',
        accessor: 'reqRef'
    },
    {
        Header: 'Category',
        accessor: 'category'
    },
    {
        Header: 'Modified By',
        accessor: 'createdBy'
    },
    {
        Header: 'Modified Date',
        accessor: 'createdAt'
    },
    {
        Header: 'Responded By',
        accessor: 'updatedBy'
    },
    {
        Header: 'Responded Date',
        accessor: 'updatedAt'
    },
    {
        Header: 'Status',
        accessor: 'status',
        fieldType: 'badge',
        customCell: true
    },
    {
        Header: 'Actions',
        accessor: 'actions',
        customCell: true,
        fieldType: 'droneServices',
        view: true,
        download: false,
        edit: false,
        delete: false,
        takeAction: false,
        viewDetails: false,
        viewComment: false
    }
];

export const NEWLY_ADDED_LOGS_TABLE_SCHEMA = [
    {
        Header: 'ID',
        accessor: 'reqRef'
    },
    {
        Header: 'Category',
        accessor: 'category'
    },
    {
        Header: 'Created By',
        accessor: 'createdBy'
    },
    {
        Header: 'Created Date',
        accessor: 'createdAt'
    },
    {
        Header: 'Responded By',
        accessor: 'updatedBy'
    },
    {
        Header: 'Responded Date',
        accessor: 'updatedAt'
    },
    {
        Header: 'Status',
        accessor: 'status',
        fieldType: 'badge',
        customCell: true
    },
    {
        Header: 'Actions',
        accessor: 'actions',
        customCell: true,
        fieldType: 'droneServices',
        view: true,
        download: false,
        edit: false,
        delete: false,
        takeAction: false,
        viewDetails: false,
        viewComment: false
    }
];

export const REGIONS = [
    {
        Header: 'Region ID',
        accessor: 'regionRef',
        customCell: true,
        fieldType: 'clickable'
    },
    {
        Header: 'Region Name',
        accessor: 'regionName'
    },
    {
        Header: 'Created By',
        accessor: 'createdBy'
    },
    {
        Header: 'Created Date',
        accessor: 'createdAt',
        customCell: true,
        fieldType: 'dateFormat'
    },
    {
        Header: 'Actions',
        accessor: 'actions',
        customCell: true,
        fieldType: 'droneServices',
        edit: true,
        delete: true
    }
];

export const VIEW_REGIONS = [
    { header: 'Region Name', accessor: 'regionName', width: 3 },
    { header: 'Created By', accessor: 'createdBy', width: 3 },
    { header: 'Created Date', accessor: 'createdAtDesc', width: 3 }
];

export const AREAS = [
    {
        Header: 'Area ID',
        accessor: 'areaRef'
    },
    {
        Header: 'Area Name',
        accessor: 'areaName'
    },
    {
        Header: 'Description',
        accessor: 'description',
        maxWidth: '200px'
        // minWidth: '100px'
    },
    {
        Header: 'Assigned Users',
        accessor: 'users',
        customCell: true,
        key: true,
        fieldType: 'clickableArray'
    },
    // {
    //     Header: 'Frequency',
    //     accessor: 'frequency'
    // },
    {
        Header: 'Pincode',
        accessor: 'pinCode'
    },
    {
        Header: 'Country',
        accessor: 'country'
    },
    {
        Header: 'State',
        accessor: 'state'
    },
    {
        Header: 'Address',
        accessor: 'address',
        maxWidth: '200px'
        // minWidth: '100px'
    },
    {
        Header: 'Created By',
        accessor: 'createdBy'
    },
    {
        Header: 'Created Date',
        accessor: 'createdAt',
        customCell: true,
        fieldType: 'dateFormat'
    },
    {
        Header: 'Modified By',
        accessor: 'updatedBy'
    },
    {
        Header: 'Modified Date',
        accessor: 'updatedAt',
        customCell: true,
        fieldType: 'dateFormat'
    },
    {
        Header: 'Is Active',
        accessor: 'acitve',
        customCell: true,
        fieldKey: 'active',
        fieldType: 'switch',
        switch: true,
        className: 'cursor-pointer'
    },
    {
        Header: 'Actions',
        accessor: 'actions',
        customCell: true,
        fieldType: 'droneServices',
        view: true,
        edit: true,
        delete: true,
        mines: true,
        deliverables: true
    }
];
export const VIEW_AREAS = [
    { header: 'Description', accessor: 'description', width: 3 },
    { header: 'Assigned Users', accessor: 'usersCount', width: 3 },
    // { header: 'Frequency', accessor: 'frequency', width: 3 },
    { header: 'Country', accessor: 'country', width: 3 },
    { header: 'State', accessor: 'state', width: 3 },
    { header: 'Address', accessor: 'address', width: 3 },
    { header: 'Created By', accessor: 'createdBy', width: 3 },
    { header: 'Created Date', accessor: 'createdAtDesc', width: 3 }
    // { header: 'Modified By', accessor: 'updatedBy', width: 3 },
    // { header: 'Modified Date', accessor: 'updatedAt', width: 3 },
    // { header: 'Is Active', accessor: 'acitve', width: 3 },
];

export const DEPARTMENTS_SCHEMA = [
    {
        Header: 'Department Name',
        accessor: 'name'
    },
    {
        Header: 'No. of Sub-categories',
        accessor: 'subCategoriesCount',
        customCell: true,
        fieldType: 'clickable'
    },
    {
        Header: 'Created By',
        accessor: 'createdBy'
    },
    {
        Header: 'Created Date',
        accessor: 'createdAt',
        customCell: true,
        fieldType: 'dateFormat'
    },
    {
        Header: 'Actions',
        accessor: 'actions',
        customCell: true,
        fieldType: 'droneServices',
        edit: true,
        delete: true
    }
];

export const VIEW_DEPARTMENTS_SCHEMA = [
    { header: 'Department Name', accessor: 'name', width: 3 },
    { header: 'Created By', accessor: 'createdBy', width: 3 },
    { header: 'Created Date', accessor: 'createdAtDesc', width: 3 }
];

export const MINES = [
    {
        Header: 'Mine ID',
        accessor: 'mineRef'
    },
    {
        Header: 'Mine Name',
        accessor: 'mineName'
    },
    {
        Header: 'Area/Distance (Hec)',
        accessor: 'distance'
    },
    {
        Header: 'Min Lat, Long',
        accessor: 'minLatLong'
    },
    {
        Header: 'Max Lat, Long',
        accessor: 'maxLatLong'
    },
    {
        Header: 'Date of Mining',
        accessor: 'miningDate'
        // customCell: true,
        // fieldType: 'dateFormat'
    },
    {
        Header: '% Completion',
        accessor: 'compeltionPercent'
    },
    {
        Header: 'Frequency',
        accessor: 'frequency'
    },

    {
        Header: 'Assigned Users',
        accessor: 'assignedUsers',
        customCell: true,
        // key:'users',
        usersCount: 'usersCount',
        fieldType: 'clickableArray'
    },
    {
        Header: 'Created By',
        accessor: 'createdBy'
    },
    {
        Header: 'Created Date',
        accessor: 'createdAt',
        customCell: true,
        fieldType: 'dateFormat'
    },
    {
        Header: 'Modified By',
        accessor: 'updatedBy'
    },
    {
        Header: 'Modified Date',
        accessor: 'updatedAt',
        customCell: true,
        fieldType: 'dateFormat'
    },
    {
        Header: 'Approved By',
        accessor: 'approvedBy'
    },
    {
        Header: 'Approved Date',
        accessor: 'approvedAt',
        customCell: true,
        fieldType: 'dateFormat'
    },
    {
        Header: 'Actions',
        accessor: 'actions',
        customCell: true,
        fieldType: 'actions',
        // view: true,
        // edit: true,
        // delete: true,
        actionList: true
    }
];

export const ALL_USERS_TABLESCHEMA = [
    {
        Header: 'EMP ID',
        accessor: 'empId'
    },
    {
        Header: 'User Name',
        accessor: 'userName'
    },
    {
        Header: 'Email ID',
        accessor: 'email'
    },
    {
        Header: 'Department',
        accessor: 'department'
    },
    {
        Header: 'Contact No',
        accessor: 'phoneNumber1'
    },
    {
        Header: 'Role',
        accessor: 'roleNames'
    },
    {
        Header: 'Assigned Areas',
        accessor: 'areasCount',
        customCell: true,
        fieldType: 'clickable'
    },
    {
        Header: 'Assigned Mines',
        accessor: 'minesCount',
        customCell: true,
        fieldType: 'clickable'
    },
    {
        Header: 'Assigned Privileges',
        accessor: 'privilegesCount',
        customCell: true,
        fieldType: 'clickable'
    },
    {
        Header: 'Address',
        accessor: 'address'
    },
    {
        Header: 'Created By',
        accessor: 'createdBy'
    },
    {
        Header: 'Created Date',
        accessor: 'createdAt',
        customCell: true,
        fieldType: 'dateFormat'
    },
    {
        Header: 'Approved By',
        accessor: 'approvedBy'
    },
    {
        Header: 'Approved Date',
        accessor: 'approvedAt',
        customCell: true,
        fieldType: 'dateFormat'
    },
    {
        Header: 'Actions',
        accessor: 'actions',
        customCell: true,
        fieldType: 'droneServices',
        view: true,
        edit: true,
        delete: true
    }
];

export const ROLES_TABLE_SCHEMA = [
    {
        Header: 'Role ID',
        accessor: 'roleId'
    },
    {
        Header: 'Role',
        accessor: 'roleName'
    },
    {
        Header: 'Privileges',
        accessor: 'privilegesCount'
    },
    {
        Header: 'Actions',
        accessor: 'actions',
        customCell: true,
        fieldType: 'droneServices',
        edit: true,
        delete: true
    }
];

export const VIEW_USERS = [
    {
        Header: 'Role',
        accessor: 'role'
    },
    {
        Header: 'UserName',
        accessor: 'email'
    }
];

export const NEW_USER_REQUESTS_TABLESCHEMA = [
    {
        Header: 'EMP ID',
        accessor: 'empId'
    },
    {
        Header: 'User Name',
        accessor: 'userName'
    },
    {
        Header: 'Email ID',
        accessor: 'email'
    },
    {
        Header: 'Department',
        accessor: 'department'
    },
    {
        Header: 'Contact No',
        accessor: 'phoneNumberDisplay'
    },
    {
        Header: 'Address',
        accessor: 'address'
    },
    {
        Header: 'Created Date',
        accessor: 'createdAt',
        customCell: true,
        fieldType: 'dateFormat'
    },
    {
        Header: 'Responded By',
        accessor: 'updatedBy'
    },
    {
        Header: 'Responded Date',
        accessor: 'updatedAt',
        customCell: true,
        fieldType: 'dateFormat'
    },
    {
        Header: 'Status',
        accessor: 'status',
        customCell: true,
        fieldType: 'badge'
    },
    {
        Header: 'Actions',
        accessor: 'actions',
        customCell: true,
        fieldType: 'droneServices',
        view: true,
        delete: true
        // viewComment: true
    }
];
